import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application.js';
import { apiurl } from '../../../../../path.js';



const ReleasefromFinance = () => {

  const operation = useContext(Application);
  const { GetProjectInfo, GetBudgetHeadInfo, ReleaseFDUTF, ViewAllReleaseFDUTF } = operation;
  const [projectId, setProjectId] = useState([]);
  const [HeadId, setHeadID] = useState([]);
  const [relatedHeadID, setRelatedHeadID] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    FinancialYear: '',
    ProjectName: '',
    ProjectID: '',
    ReleaseAmountTillDate: '',
    BudgetHeadID: null,
    BudgetHeadName: "",
    ReleaseAmount: 0,
    ReleaseDate: null,
  });

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  }

  const formData = new FormData();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      for (const key in data) {
        formData.append(key, data[key]);
      }
      let ReleaseSanctionCopy = document.getElementById("ReleaseSanctionCopy").files;
      formData.append("ReleaseSanctionCopy", ReleaseSanctionCopy[0]);
      let result = await ReleaseFDUTF(formData);
      console.log(result)
      if (result.message) {
        alert(result.message)
        window.location.reload();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }

  };

  console.log("Head if ", HeadId)

  // Fetching 
  const FetchData = async () => {
    try {
      let res = await GetProjectInfo('null', "all");
      let res1 = await GetBudgetHeadInfo('null', "all");
      let res3 = await ViewAllReleaseFDUTF();
      console.log("Tbale data ::", res3);
      setProjectId(res);
      setHeadID(res1);
      setTableData(res3)
    }
    catch (err) {
      console.log(err);
    }
  }

  const HeadIDFetchOperation = async (ID, IDtype) => {
    try {
      console.log(ID);
      if (IDtype == "ProjectId") {
        let res1 = await GetProjectInfo(ID, "id");
        console.log("Project ID ingo :: ", res1);
        let projectData = res1[0];

        console.log("project data i sleected ", projectData);

        let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
        console.log("Head related to project ", apple)
        setRelatedHeadID(apple);



        setData((prev) => ({
          ...prev,
          FinancialYear: projectData.FinancialYear,
          ProjectName: projectData.ProjectName,
          ProjectID: projectData.ProjectId,
          ReleaseAmountTillDate: projectData.ProjectCost,
          ProjectCost: projectData.ProjectCost,
          piu: projectData.PIU,
          GRCopy: projectData.GRCopy
        }))
      } else if (IDtype == "HeadID") {
        let res1 = await GetBudgetHeadInfo(ID, 'id');
        console.log("Head ID info ", res1);
        let HeadData = res1[0];
        setData((prev) => ({
          ...prev,
          BudgetHeadID: HeadData.HeadID,
          BudgetHeadName: HeadData.HeadName,
        }))
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  const uniqueHeads = [];

  const filteredData = HeadId.filter(item => {
    const isDuplicate = uniqueHeads.includes(item.HeadName);
    if (!isDuplicate) {
      uniqueHeads.push(item.HeadName);
      return true;
    }
    return false;
  });


  console.log("Filltered Data ", filteredData)

  useEffect(() => {
    FetchData()
  }, [])




  return (
    <>
      <div className="col-12 ">
        <h3 className='text-center fw-bold bg-light'>Release From Finance Head Wise</h3>
        <div className="col-12 m-auto my-5 budgetContainer">
          <div className="m-auto budgetElement">
            {loading && (
              <div className="loader"></div>
            )}
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Financial Year</label>
                  </div>
                  <div className="col-7">
                    <select name="FinancialYear" value={data.FinancialYear} id="" className='py-2' onChange={HandleChangeData}>
                      <option value="null">Choose Financial Year</option>
                      <option value="2024-2025">2024 - 2025</option>
                      <option value="2025-2026">2025 - 2026</option>
                    </select>
                  </div>
                </div>
              </div>
{/* 
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className='my-auto' >Project Name</label>
                  </div>
                  <div className="col-7">
                    <select name="ProjectID" value={data.ProjectID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value, "ProjectId") }}>
                      < option value="null">Choose Project</option>
                      {projectId && projectId.map((val, index) => {
                        return (
                          <option key={index} value={val.ProjectId}>{val.ProjectName}</option>
                        )
                      })
                      }
                    </select>
                  </div>
                </div>
              </div> */}

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Budget Head</label>
                  </div>
                  <div className="col-7">
                    <select name="BudgetHeadID" value={data.BudgetHeadID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value, "HeadID") }}>
                      < option>Choose Head Budget Type</option>
                      {filteredData && filteredData.map((val, index) => {
                        return (
                          <option key={index} value={val.HeadID}>{val.HeadName}</option>
                        )
                      })
                      }
                    </select>
                  </div>
                </div>
              </div>
             
              
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className='my-auto'>Release Amount</label>
                  </div>
                  <div className="col-7">
                    <input type="number" placeholder='Enter Release Amount' className='form-control py-2' name='ReleaseAmount' value={data.ApprovedWorkAmount} onChange={HandleChangeData} />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Release Date</label>
                  </div>
                  <div className="col-7">
                    <input type="datetime-local" placeholder='Enter Release Date' className='form-control py-2' value={data.WorkOrderDate} name='ReleaseDate' onChange={HandleChangeData} />
                  </div>
                </div>
              </div>

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Release Sanction Copy Upload</label>
                  </div>
                  <div className="col-7">
                    <input type="file" className='form-control py-2' id='ReleaseSanctionCopy' />
                  </div>
                </div>
              </div>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  <div className="col-5">
                  </div>
                  <div className="col-7">
                    <div className="col-12">
                      <button className='px-4 py-1 btn btn-primary' onClick={handleSubmit}> Save</button>
                      <button className='px-4 py-1 btn btn-danger mx-4'> Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>



      {
        tableData &&
        <div className="col-11 m-auto">
          <div className="row">

            <table className='table  table-striped'>
              <thead className='table-info'>
                <tr>
                  <th>Sr no </th>
                  <th>Financial Year</th>
                  <th>Project Name </th>
                  <th>Project Cost</th>
                  <th>Release Amount</th>
                  <th>Release Date</th>
                </tr>
              </thead>
              <tbody>
                {
                  tableData.map((val, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{val.FinancialYear}</td>
                        <td>{val.ProjectName}</td>
                        <td>{val.ReleaseAmountTillDate}</td>
                        <td>{val.ReleaseAmount}</td>
                        <td>{new Date(val.ReleaseDate).toLocaleString()}</td>

                      </tr>

                    )
                  })
                }
              </tbody>
            </table>


          </div>
        </div>
      }



    </>
  )
}

export default ReleasefromFinance
